import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

export const RECOMMENDED_BY_ORGANIZATION = '20e9163f-1377-4322-b485-3115b607152c';
export const RECOMMENDED_BY_AGENT = '68ccd2bc-6c8a-4b1c-98d6-fc6faab81e0a';
export const SPONSORED_BY_MILESTONES = '97bd78f5-b5d4-4093-b508-9fde19e21ff0';

export const TYPES = {
    RECOMMENDED_BY_ORGANIZATION,
    RECOMMENDED_BY_AGENT,
    SPONSORED_BY_MILESTONES
};

class ServiceProviderRecommendationTypeAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'service-provider-recommendation-type';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'services/providers/recommendations/types';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'slug',
            'title',
        ];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            slug: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
        };
    }
}

export default ServiceProviderRecommendationTypeAppResource;
